import { render, staticRenderFns } from "./common-search.vue?vue&type=template&id=47bc1caa&"
import script from "./common-search.vue?vue&type=script&lang=js&"
export * from "./common-search.vue?vue&type=script&lang=js&"
import style0 from "./common-search.vue?vue&type=style&index=0&id=47bc1caa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports